module.exports = __webpack_public_path__ + "cdee495732a24fe535e87c1bc053f0b0.svg";